import yup from "src/utils/yup/extensionMethods";

const addAndChangeSchema = (translate: Function) => yup.object().shape({
	oca004Descricao: yup.string().required(translate("Descrição categoria de ocorrência é requerida")),
	oca004Efa005Id: yup.string().required(translate("Usuário responsavel é requerido")),
	oca004Efa005Id2: yup.string().required(translate("Usuário autoridade é requerido")),	
	octba006: yup.array().of(yup.object().shape({
		oca006Id: yup.number(),
		oca006NotificaParticipante: yup.string(),
		oca006Tipo: yup.string(),
		oca006Efa005Id: yup.number().nullable(),
		oca006Efa004Id: yup.number().nullable(),
		hasOneOfTwoValues: yup.boolean().oneOf([true]).required(translate("Usuário é requerido"))
	}))
		.unique(translate("Consultados não podem ser repetidos"), (a: any) => a.oca006Efa005Id, (a: any) => !a.oca006Efa004Id && a.oca006Tipo === "C")
		.unique(translate("Informados não podem ser repetidos"), (a: any) => a.oca006Efa005Id, (a: any) => !a.oca006Efa004Id && a.oca006Tipo === "I")
		.unique(translate("Consultados não podem ser repetidos"), (a: any) => a.oca006Efa004Id, (a: any) => !a.oca006Efa005Id && a.oca006Tipo === "C")
		.unique(translate("Informados não podem ser repetidos"), (a: any) => a.oca006Efa004Id, (a: any) => !a.oca006Efa005Id && a.oca006Tipo === "I"),
		
	octba005: yup.array().of(yup.object().shape({
		oca005Dias: yup.number().nullable(),
		oca005Efa005Id: yup.number(),
		oca005Utiliza: yup.string()
	}))	
});

export default addAndChangeSchema;
